import {
    MANAGE_COMMENTS_TRACKER,
    MANAGE_DM_TRACKER,
    MANAGE_IMPORTANT_TRACKER,
    MANAGE_MENTIONS_TRACKER,
    MANAGE_RESOLVED_TRACKER
} from '@/lib/routes/privateRoutes';

export const SOCIAL_INBOX_META = {
    comment: {
        key: 'comment',
        icon: 'bubble-outline',
        activeIcon: 'bubble',
        url: MANAGE_COMMENTS_TRACKER
    },
    mention: {
        key: 'mention',
        icon: 'mentions',
        activeIcon: 'mentions',
        url: MANAGE_MENTIONS_TRACKER
    },
    dm: {
        key: 'dm',
        icon: 'dm',
        activeIcon: 'dm',
        url: MANAGE_DM_TRACKER
    },
    important: {
        key: 'important',
        icon: 'flag',
        activeIcon: 'flag',
        url: MANAGE_IMPORTANT_TRACKER,
        status: 'important'
    },
    resolved: {
        key: 'resolved',
        icon: 'check-circle-outline',
        activeIcon: 'check-circle',
        url: MANAGE_RESOLVED_TRACKER,
        status: 'resolved'
    }
} as const;

export const CONVERSATIONS_REFRESH_INTERVAL = 30000; // 30 sec

export const DEFAULT_SOCIAL_INBOX_TYPES = [
    SOCIAL_INBOX_META.comment.key,
    SOCIAL_INBOX_META.mention.key,
    SOCIAL_INBOX_META.dm.key
] as const;

export const SOCIAL_INBOX_MANAGING_OPTIONS = [
    SOCIAL_INBOX_META.important.key,
    SOCIAL_INBOX_META.resolved.key
] as const;

export const INSTAGRAM_ONLY_FEATURES = [SOCIAL_INBOX_META.mention.key] as const;

export const DM_PARTICIPANT_ROLES = {
    initiator: 'initiator',
    recipient: 'recipient'
} as const;

// TODO: Move labels to translate file and use the key to map it instead
// ex.: conversation.sort.newest = "Newest First"
export const SORT_OPTIONS = [
    { value: 'desc', label: 'Newest First' },
    { value: 'asc', label: 'Oldest First' }
] as const;

// TODO: Move labels to translate file and use the key to map it instead
// ex.: conversation.dm.filters.all = "All"
export const DM_FILTER_OPTIONS = [
    { value: 'all', label: 'All' },
    { value: 'unread', label: 'Unread' },
    { value: 'read', label: 'Read' }
] as const;

export const DEFAULT_SELECTED_MESSAGES: Record<keyof typeof SOCIAL_INBOX_META, string[]> = {
    [SOCIAL_INBOX_META.comment.key]: [],
    [SOCIAL_INBOX_META.mention.key]: [],
    [SOCIAL_INBOX_META.dm.key]: [],
    [SOCIAL_INBOX_META.important.key]: [],
    [SOCIAL_INBOX_META.resolved.key]: []
} as const;

export const DM_STATUS = {
    SENDING: 'sending',
    FAILED: 'failed',
    SENT: 'sent'
} as const;

export const DM_TYPES = {
    TEXT: 'text',
    FILE: 'file'
} as const;

export const SUPPORTED_ATTACHMENT_TYPES = ['image', 'video', 'gif', 'sticker'] as const;

export const FACEBOOK_MESSAGING_TYPE = {
    RESPONSE: 'RESPONSE',
    MESSAGE_TAG: 'MESSAGE_TAG',
    UPDATE: 'UPDATE'
} as const;
